import React, {useCallback, useEffect, useState} from 'react';
import TitleMain from "../../components/Title/TitleMain";
import { useModal } from '../../contexts/ModalContext';
import GridTabFolding from "../../components/Grid/GridTabFolding";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faDownLong, faExternalLink, faFemale, faUpLong, faXmark} from "@fortawesome/free-solid-svg-icons";
import styles from "../../components/Grid/GridTabFolding.module.css";
import styles_filter from "../../components/Filter/Filter.module.css";
import {useUser} from "../../contexts/UserContext";
import {getParticipants, parseForListeUtilisateurs, USER_STATUS} from "../../services/UserService";
import FilterHamburger from "../../components/Filter/FilterHamburger";
import {Link, useLocation, useNavigate} from "react-router-dom";
import FilterHamburgerCustom from "../../components/Filter/FilterHamburgerCustom";
import TitleSecondary from "../../components/Title/TitleSecondary";
import {ReactComponent as AnnulerIcon} from "../../icons/annuler.svg";
import {ReactComponent as AjouterIcon} from "../../icons/ajouter.svg";
import {Field, Form, Formik} from "formik";
import {fetchGetEntreprises, fetchGetEntreprisesWithContratBetweenDates} from "../../services/EntrepriseService";
import styles_field from "../../components/Field/Field.module.css";
import Routing from "../../services/routing";
import {filteredDataTabSearch, getNestedValue} from "../../services/UtilsService";
import TableSearch from "../../components/Table/TableSearch";
import SearchEntreprise from "../../components/Search/SearchEntreprise";



function ListeUtilisateurPage({ title = "VOTRE PROFIL"}) {
    const { showModal, hideModal } = useModal();
    const { user } = useUser();
    const [ utilisateurs, setUtilisateurs ] = useState([]);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [lienAjouterSalarie, setLienAjouterSalarie] = useState("");
    const handleSearch = (event) => { setSearchQuery(event.target.value);};

    const handleSuccess = (children = "Succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const handleFilterSubmit = (filters) => {
        const filterValues = Object.entries(filters)
            .filter(([key, val]) => val)
            .map(([key]) => key)
            .join(',');

        updateURLParams("filter", filterValues);
    };

    const handleSortSubmit = (sort) => {
        updateURLParams('sort', sort.sortOptions);
    };

    const updateURLParams = (type, value) => {
        switch (type) {
            case 'filter':
                if (value) {
                    params.set("filter", value);
                } else {
                    params.delete("filter");
                }
                break;
            case 'sort':
                params.set('sort', value);
                break;
            default:
                break;
        }

        navigate(`${location.pathname}?${params.toString()}`);
    };

    useEffect(() => {
        getData();
    }, [location.search]);

    const columns = [
        { header: 'NOM', field: 'name' },
        { header: 'SEXE', field: 'sexe' },
        { header: 'STATUT', field: 'status' },
    ];

    const getData = async () => {
        const queryParams = location.search;

        const entrepriseParam = params.get("filter_ent");
        // Vérifier si l'utilisateur est admin est si oui et que pas de params "ent" alors affiché un <SearchEntreprise />
        if (user.roles.includes("ROLE_ADMIN") && !params.has("filter_ent")) {
            return console.warn("Séléctionnez une entreprise en parametre, exemple ?ent=14");
        }

        const result = await getParticipants(queryParams);
        if (result.success) {
            setUtilisateurs(parseForListeUtilisateurs(result.users));
            setLienAjouterSalarie(result.lienAjouter);
            // handleSuccess(result.message);
        } else {
            handleError(result.message);
        }
    }

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        params.delete(`filter_${key}`);
        navigate(`?${params.toString()}`);
    }

    const updateFilter = (filterKey, filterValue, resetFilter = false) => {
        const params = new URLSearchParams(location.search);
        let existingFilters = params.get(filterKey);
        existingFilters = existingFilters ? existingFilters.split(',') : [];

        if (resetFilter) {
            if (existingFilters.includes(filterValue)) {
                existingFilters = existingFilters.filter(value => value !== filterValue);
            } else {
                existingFilters = [filterValue];
            }
        } else {
            if (existingFilters.includes(filterValue)) {
                existingFilters = existingFilters.filter(value => value !== filterValue);
            } else {
                existingFilters.push(filterValue);
            }
        }

        if (existingFilters.length > 0) {
            params.set(filterKey, existingFilters.join(','));
        } else {
            params.delete(filterKey);
        }

        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const childrenOfFilter = (
        <div style={{display: "flex", flexDirection: "column", gap: "10px", margin: "35px"}}>
            <TitleSecondary text="Filtres"/>

            <div className={styles_filter.filtersRemoveBar}>
                {/* Aficher tous les parametres de l'url commençant par filter_ */}
                {Array.from(params.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        let valueStr = value;
                        let keyStr = key.replace('filter_', '');
                        if (key === 'filter_civilite') {
                            valueStr = value === '4' ? 'Homme' : 'Femme';
                            keyStr = "Civilité";
                        }

                        if (key === 'filter_actif') {
                            valueStr = value === 'true' ? 'Oui' : 'Compte inactif';
                            keyStr = "Actif";
                        }

                        if (key === 'filter_status') {
                            valueStr = value === "4" ? 'Oui' : 'Compte actif';
                            keyStr = "Supprimé";
                        }


                        if (key === 'filter_participation') {
                            keyStr = "Participation";
                        }

                        if (key === 'filter_ent') {
                            valueStr = value;
                            keyStr = "Entreprise";
                        }


                        return (
                            <button key={key} className={styles_filter.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcon />
                                <span className={"filter_key"}>{keyStr}</span> : {valueStr}
                            </button>
                        );
                    })
                }
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
                <button className={styles_filter.btnFiltre} onClick={() => updateFilter('filter_civilite', '4', true)}>Homme</button>
                <button className={styles_filter.btnFiltre} onClick={() => updateFilter('filter_civilite', '3', true)}>Femme</button>
                <button className={styles_filter.btnFiltre} onClick={() => updateFilter('filter_actif', 'true')}>Compte actif</button>
                <button className={styles_filter.btnFiltre} onClick={() => updateFilter('filter_status', USER_STATUS.supprime.value)}>Compte supprimé</button>
            </div>

            <div style={{display: "flex", flexDirection: "column"}}>
                <button className={styles_filter.btnFiltre}
                        onClick={() => updateFilter('filter_participation', '1-10')}>Participation entre 1 et 10
                </button>

                <button className={styles_filter.btnFiltre}
                        onClick={() => updateFilter('filter_participation', '11-20')}>Participation entre 11 et 20
                </button>

                <button className={styles_filter.btnFiltre}
                        onClick={() => updateFilter('filter_participation', '20+')}>Participation 20 et +
                </button>
            </div>

            <div>
                Connecté depuis le <div className={styles_field.field}><input type="date" onChange={e => updateFilter('filter_connected_since', e.target.value)} /></div>
            </div>

            <div>
                <span>Entreprise</span>
                {user.roles.includes("ROLE_ADMIN") && (
                    <SearchEntreprise onSubmit={(query) => {
                        const entrepriseId = query.entrepriseId;
                        const label = query.query;
                        if (entrepriseId) {
                            params.set("filter_ent", entrepriseId);
                            navigate(`?${params.toString()}`);
                        }
                    }} placeholder={"Rechercher une entreprise"}/>
                )}
            </div>

        </div>
    );

    const filteredSalariesSearch = (data, colonnes, searchQuery) => {
        return data.filter((datum) => {
            return colonnes.some((column) => {
                const value = getNestedValue(datum, column.field);
                return value && value.toString().toLowerCase().includes(searchQuery.toLowerCase());
            });
        });
    }

    const filteredUtilisateurs = filteredSalariesSearch(utilisateurs, columns, searchQuery);

    return (
        <div className="content">
            <TitleMain text={title}/>

            <div style={{ display: "flex", flexDirection: "column" }}>
                <Link to={Routing.routes.salarieCrmHistory} className={styles.link}><FontAwesomeIcon icon={faExternalLink}/> Consulter l'historique CRM</Link>
                <Link to={Routing.routes.statsUsers} className={styles.link}><FontAwesomeIcon icon={faExternalLink} /> Statistiques utilisateurs</Link>

                <Link to={Routing.routes.salariesImport} className={styles.link}>
                    <AjouterIcon />
                    Ajouter un utilisateur
                </Link>
            </div>

            <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end", margin: "12px"}}>
                <FilterHamburgerCustom onReinirFilters={() => navigate(`${location.pathname}`)} children={childrenOfFilter}/>
                <TableSearch onSearch={handleSearch} value={searchQuery} />
            </div>

            <GridTabFolding listData={filteredUtilisateurs} columns={columns}/>

        </div>
    );
}

export default ListeUtilisateurPage;
